import React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import PharmacyTabs, { PharmacyTabValue } from './PharmacyTabs';
import InvoiceSearchBar from '../../../components/Billing/Invoice/InvoiceSearchBar';
import { ReactComponent as FilterIcon } from '../../../assets/SVG/filter.svg';
import NewInvoiceButton from '../../../components/Billing/Invoice/NewInvoiceButton';
import { FilterIconSx } from './PharmacyPatientSelector.styles';

interface PharmacyHeaderProps {
  activeTab: PharmacyTabValue;
  onTabChange: (tab: PharmacyTabValue) => void;
  search: string;
  onSearchChange: (val: string) => void;
  onOpenFilter: () => void;
  onNewInvoice: () => void;
  showHeader?: boolean;
}

const PharmacyHeader: React.FC<PharmacyHeaderProps> = ({
  activeTab,
  onTabChange,
  search,
  onSearchChange,
  onOpenFilter,
  onNewInvoice,
  showHeader = true,
}) => (
  <Grid
    container
    spacing={2}
    alignItems="center"
    sx={{ my: 2, width: '100%' }}
    wrap="wrap"
  >
    {/* Tabs - Left side */}
    <Grid
      size={{ xs: 12, sm: 12, md: 4, lg: 3 }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        mb: { xs: 2, md: 0 },
        justifyContent: { xs: 'center', md: 'flex-start' },
      }}
    >
      <PharmacyTabs activeTab={activeTab} onTabChange={onTabChange} />
    </Grid>

    {/* Filter, Search, Add New Invoice - Right side */}
    <Grid
      size={{ xs: 12, sm: 12, md: 8, lg: 9 }}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        justifyContent: { xs: 'center', sm: 'flex-end' },
        gap: 1.5,
      }}
    >
      {/* Filter Icon */}
      <IconButton 
        aria-label="Filter" 
        onClick={onOpenFilter}
      >
        <FilterIcon style={FilterIconSx} />
      </IconButton>

      {/* Search Bar */}
      {showHeader && (
        <Box sx={{ width: { xs: '100%', sm: 260 } }}>
          <InvoiceSearchBar 
            value={search} 
            onChange={onSearchChange} 
            placeholder="Search Patient by name, ID"
            height={44}
            minWidth={220}
          />
        </Box>
      )}
      {/* Add New Invoice Button */}
      <NewInvoiceButton onClick={onNewInvoice} />
    </Grid>
  </Grid>
);

export default PharmacyHeader;
